var _defs, _style, _ellipse, _path, _g, _g2, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 323,
    viewBox: "0 0 536 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ggGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d27c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0922e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ggGoldSoft",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6c469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a87d28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ggGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D4AF37",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4AF37",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .balloon { animation: ggFloat 5.5s ease-in-out infinite; will-change: transform; }\n    .b1 { animation-duration: 5.6s; animation-delay: -0.2s; }\n    .b2 { animation-duration: 6.4s; animation-delay: -1.3s; }\n    .b3 { animation-duration: 6.0s; animation-delay: -0.7s; }\n    .b4 { animation-duration: 6.8s; animation-delay: -2.0s; }\n    @keyframes ggFloat {\n      0%   { transform: translateY(0px); }\n      50%  { transform: translateY(-6px); }\n      100% { transform: translateY(0px); }\n    }\n    @media (prefers-reduced-motion: reduce) {\n      .balloon { animation: none; }\n    }\n  ")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268,
    cy: 160,
    rx: 250,
    ry: 150,
    fill: "url(#ggGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 74 Q268 158 500 74",
    stroke: "url(#ggGold)",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.8 100.9 L137.8 100.9 L128.8 120.9 Z",
    fill: "url(#ggGoldSoft)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.2 109.3 L184.2 109.3 L175.2 129.3 Z",
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6 114.3 L230.6 114.3 L221.6 134.3 Z",
    fill: "url(#ggGoldSoft)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 116 L277 116 L268 136 Z",
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4 114.3 L323.4 114.3 L314.4 134.3 Z",
    fill: "url(#ggGoldSoft)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8 109.3 L369.8 109.3 L360.8 129.3 Z",
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2 100.9 L416.2 100.9 L407.2 120.9 Z",
    fill: "url(#ggGoldSoft)",
    opacity: 0.85
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "balloon b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 130 q10 22 -3 40 q-12 16 3 34",
    stroke: "url(#ggGold)",
    strokeWidth: 1.4,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 96,
    rx: 26,
    ry: 32,
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 85,
    rx: 7,
    ry: 11,
    fill: "#fff6dd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 127 l-5 8 h10 z",
    fill: "#c0922e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "balloon b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 100 q11 24 -2 44 q-13 18 3 38",
    stroke: "url(#ggGold)",
    strokeWidth: 1.4,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 64,
    rx: 28,
    ry: 34,
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 52,
    rx: 7.5,
    ry: 12,
    fill: "#fff6dd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 97 l-5 8 h10 z",
    fill: "#c0922e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "balloon b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344 103 q10 22 -3 40 q-11 16 3 34",
    stroke: "url(#ggGoldSoft)",
    strokeWidth: 1.3,
    fill: "none",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344,
    cy: 72,
    rx: 25,
    ry: 31,
    fill: "url(#ggGoldSoft)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336,
    cy: 61,
    rx: 6.5,
    ry: 10.5,
    fill: "#fff6dd",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 102 l-4 7 h8 z",
    fill: "#a87d28"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "balloon b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452 125 q11 22 -3 40 q-12 16 3 34",
    stroke: "url(#ggGold)",
    strokeWidth: 1.4,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452,
    cy: 92,
    rx: 27,
    ry: 33,
    fill: "url(#ggGold)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 444,
    cy: 81,
    rx: 7,
    ry: 11,
    fill: "#fff6dd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 124 l-5 8 h10 z",
    fill: "#c0922e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 43 C150 52 153 55 162 55 C153 55 150 58 150 67 C150 58 147 55 138 55 C147 55 150 52 150 43 Z",
    fill: "url(#ggGold)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300 57 C300 63.75 302.25 66 309 66 C302.25 66 300 68.25 300 75 C300 68.25 297.75 66 291 66 C297.75 66 300 63.75 300 57 Z",
    fill: "url(#ggGold)",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268 144 C268 156 272 160 284 160 C272 160 268 164 268 176 C268 164 264 160 252 160 C264 160 268 156 268 144 Z",
    fill: "url(#ggGold)",
    opacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M430 166 C430 176.5 433.5 180 444 180 C433.5 180 430 183.5 430 194 C430 183.5 426.5 180 416 180 C426.5 180 430 176.5 430 166 Z",
    fill: "url(#ggGoldSoft)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205 205 C205 212.5 207.5 215 215 215 C207.5 215 205 217.5 205 225 C205 217.5 202.5 215 195 215 C202.5 215 205 212.5 205 205 Z",
    fill: "url(#ggGold)",
    opacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 58,
    r: 4,
    fill: "#e6c469",
    opacity: 0.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 150,
    r: 5,
    fill: "#D4AF37",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 215,
    r: 3,
    fill: "#f4d27c",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 180,
    r: 4,
    fill: "#D4AF37",
    opacity: 0.65
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 120,
    r: 2.5,
    fill: "#e6c469",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 120,
    r: 3,
    fill: "#f4d27c",
    opacity: 0.75
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 232,
    r: 3,
    fill: "#e6c469",
    opacity: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 200,
    width: 8,
    height: 8,
    rx: 1.5,
    fill: "#D4AF37",
    opacity: 0.7,
    transform: "rotate(25 114 204)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 205,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#e6c469",
    opacity: 0.75,
    transform: "rotate(-20 391.5 208.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 120,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#c0922e",
    opacity: 0.8,
    transform: "rotate(40 61 123)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 178,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#f4d27c",
    opacity: 0.7,
    transform: "rotate(15 303.5 181.5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 150,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#D4AF37",
    opacity: 0.6,
    transform: "rotate(-30 177 153)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 205,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#e6c469",
    opacity: 0.7,
    transform: "rotate(30 255 208)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsImage);
export default __webpack_public_path__ + "static/media/eventsImage.e730bd1b2a92c6f73fe0e3a265a151ab.svg";
export { ForwardRef as ReactComponent };